const CONTROLLED_INPUT_CLASS = '.js-controlled-input';

const controlledInput = {
  initialize() {
    this.createEvents();
  },

  createEvents() {
    $('body').on('click', `${CONTROLLED_INPUT_CLASS} button`, (e) => {
      const $btn = $(e.currentTarget);
      const inc = parseInt($btn.data('inc'), 10);
      const $input = this.getControlledInputEl($btn).find('input');

      this.incrementInput($input, inc);
    });

    $('body').on('blur', `${CONTROLLED_INPUT_CLASS} input`, (e) => {
      const $input = $(e.currentTarget);
      this.validateInput($input);
      this.checkDisabledStates($input);
    });

    // Check disabled state initially
    $(`${CONTROLLED_INPUT_CLASS} input`).toArray().forEach((input) => {
      this.checkDisabledStates($(input));
    });
  },

  /**
   * Get the controlled input wrapper element given one of it's children
   * @param {Object} $el jQuery child of controlled input element
   * @return {Object} Controlled input element
   */
  getControlledInputEl($el) {
    return $el.parents(CONTROLLED_INPUT_CLASS);
  },

  /**
   * Get numeric attribute for element or fallback
   * @param {Object} $el jQuery element
   * @param {String} key Attribute key
   * @param {String|Number} fallback Fallback value if the attribute doesn't exist
   * @return {String|Number}
   */
  getAttr($el, key, fallback) {
    return $el.attr(key) ? parseInt($el.attr(key), 10) : fallback;
  },

  /**
   * Get the input, min and max values for an input field
   * @param {Object} $input jQuery input element object
   * @return {Object}
   */
  getInputReach($input) {
    return {
      input: parseInt($input.val(), 10),
      min: this.getAttr($input, 'min', 0),
      max: this.getAttr($input, 'max', Infinity),
    };
  },

  /**
   * Increment the input value
   * @param {Object} $input jQuery input element
   * @param {Number} inc Increment the input element with this value
   * @return {void}
   */
  incrementInput($input, inc) {
    const { input } = this.getInputReach($input);
    const newVal = input + inc;

    $input.val(newVal).trigger('change');

    this.validateInput($input);
    this.checkDisabledStates($input);
  },

  /**
   * Validate the input field value
   * @param {Object} $input jQuery input element
   * @return {void}
   */
  validateInput($input) {
    const { input, min, max } = this.getInputReach($input);
    let mutatedInput = input;

    if (mutatedInput < min) {
      mutatedInput = min;
    }

    if (mutatedInput > max) {
      mutatedInput = max;
    }

    if (mutatedInput !== input) {
      $input.val(mutatedInput).trigger('change');
    }
  },

  /**
   * Check the availability of the plus and min buttons
   * @param {Object} $input Input element
   * @return {void}
   */
  checkDisabledStates($input) {
    const { input, min, max } = this.getInputReach($input);
    const $controlledInput = this.getControlledInputEl($input);

    $controlledInput.find('.is-down').prop('disabled', input <= min);
    $controlledInput.find('.is-up').prop('disabled', input >= max);
  },
};

export default controlledInput;
